import { render } from "./ItemComp.vue?vue&type=template&id=e24a1778"
import script from "./ItemComp.vue?vue&type=script&lang=js"
export * from "./ItemComp.vue?vue&type=script&lang=js"

import "./ItemComp.vue?vue&type=style&index=0&id=e24a1778&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\compro.rimba.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__